import { combineReducers } from "redux";
import mainReducer from "./reducers/mainReducer";
import productReducer from "./reducers/savedProductReducer";

export const rootReducer = combineReducers({
  main: mainReducer,
  product: productReducer,
});
